import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="200"
    fill="none"
    viewBox="0 0 28 39"
  >
    <path d="M13.9999 38.1537C12.9897 38.1537 12.1185 37.8037 11.3865 37.1037C10.6544 36.4037 10.2564 35.5486 10.1922 34.5384H17.8076C17.7435 35.5486 17.3454 36.4037 16.6134 37.1037C15.8813 37.8037 15.0102 38.1537 13.9999 38.1537ZM6.49996 31.7691V28.7691H21.4999V31.7691H6.49996ZM6.80764 25.9999C4.71278 24.6973 3.05446 22.9954 1.83268 20.8941C0.610893 18.7928 0 16.4948 0 13.9999C0 10.1025 1.35897 6.79484 4.0769 4.0769C6.79484 1.35897 10.1025 0 13.9999 0C17.8973 0 21.205 1.35897 23.923 4.0769C26.6409 6.79484 27.9999 10.1025 27.9999 13.9999C27.9999 16.4948 27.389 18.7928 26.1672 20.8941C24.9454 22.9954 23.2871 24.6973 21.1922 25.9999H6.80764ZM7.69993 22.9999H20.2999C21.7999 21.9333 22.9583 20.6166 23.7749 19.0499C24.5916 17.4833 24.9999 15.7999 24.9999 13.9999C24.9999 10.9333 23.9333 8.33326 21.7999 6.19993C19.6666 4.06659 17.0666 2.99993 13.9999 2.99993C10.9333 2.99993 8.33326 4.06659 6.19993 6.19993C4.06659 8.33326 2.99993 10.9333 2.99993 13.9999C2.99993 15.7999 3.40826 17.4833 4.22493 19.0499C5.04159 20.6166 6.19993 21.9333 7.69993 22.9999Z" fill="currentColor"/>
  </svg>
);

export default SvgIcon;
